// extracted by mini-css-extract-plugin
export default {"TagName":"AdminSidebar_TagName__SXFyt","TagItems":"AdminSidebar_TagItems__Gbqgz","SideSmall":"AdminSidebar_SideSmall__1SVX1","SideFull":"AdminSidebar_SideFull__o-qfb"};